import $ from 'jquery';
import 'slick-carousel';

const removeInlineStyles = () => {
  const sliderItems = document.querySelectorAll('.slider-item');

  sliderItems.forEach((item) => {
    item.removeAttribute('style');
  });
};

const initCarousel = () => {
  const iframeSliders = document.querySelectorAll('[js-iframe-slider]');

  if (iframeSliders) {
    Array.prototype.forEach.call(iframeSliders, slider => {
      const mainSlider = slider.querySelectorAll('[js-iframe-slider-main]')[0];
      const tabsSlider = slider.querySelectorAll('[js-iframe-slider-tabs]')[0];

      $(mainSlider).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        asNavFor: tabsSlider,
        arrows: true,
        prevArrow: slider.querySelectorAll('[js-iframe-slider-prev]')[0],
        nextArrow: slider.querySelectorAll('[js-iframe-slider-next]')[0],
        infinite: true
      });

      $(tabsSlider).slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        asNavFor: mainSlider,
        dots: false,
        centerMode: true,
        focusOnSelect: true,
        arrows: false,
        infinite: true
      });

      // Make the first tab active initially
      $(tabsSlider).find('.slider-tab').first().addClass('slick-active');
    });

    removeInlineStyles();
  }
};

const updateTabState = (slider) => {
  const mainSlider = $(slider).find('[js-iframe-slider-main]');
  const tabsSlider = $(slider).find('[js-iframe-slider-tabs]');

  // Update the active state of the tabs
  mainSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    tabsSlider.find('.slider-tab').removeClass('slick-active');
    tabsSlider.find('.slider-tab').eq(nextSlide).addClass('slick-active');
  });
}

const iframeSlider = async () => {
  initCarousel();

  $('.slider').each(function() {
    updateTabState(this);
  });

  $('.slider-tab').on('click', function() {
    $('.slider-tab').removeClass('slick-active');  // Remove the active class from all tabs
    $(this).addClass('slick-active');  // Add the active class to the clicked tab
  });
};

export default iframeSlider;
